import { defaultAxiosInstance } from '../config/axiosConfig';

const compactParams = (values = {}) =>
  Object.fromEntries(
    Object.entries(values).filter(([, value]) => value !== undefined && value !== null && value !== '')
  );

class ResourceSharingService {
  async createShare(payload) {
    const response = await defaultAxiosInstance.post('/shares/', payload);
    return response.data;
  }

  async getResourceShares(resourceType, resourceId) {
    const response = await defaultAxiosInstance.get(
      `/shares/resource/${encodeURIComponent(resourceType)}/${encodeURIComponent(resourceId)}`
    );
    return response.data;
  }

  async updateShare(shareId, payload) {
    const response = await defaultAxiosInstance.patch(`/shares/${shareId}`, payload);
    return response.data;
  }

  async revokeShare(shareId) {
    const response = await defaultAxiosInstance.delete(`/shares/${shareId}`);
    return response.data;
  }

  async getSharedWithMe(resourceType) {
    const response = await defaultAxiosInstance.get('/shares/shared-with-me', {
      params: compactParams({ resource_type: resourceType }),
    });
    return response.data;
  }

  async getCompanyResources({ resourceType, userId, search, limit = 25, offset = 0 }) {
    const response = await defaultAxiosInstance.get('/shares/company-resources', {
      params: compactParams({
        resource_type: resourceType,
        user_id: userId,
        search,
        limit,
        offset,
      }),
    });
    return response.data;
  }

  async getAgentAttachments(agentId) {
    const response = await defaultAxiosInstance.get(`/shares/agents/${agentId}/attachments`);
    return response.data;
  }

  async getAgentToolStatus(agentId) {
    const response = await defaultAxiosInstance.get(`/dynamic-agent/${agentId}/tool-status`);
    return response.data;
  }

  // A share recipient's own DIM3 folders for an agent. The GET doubles as the
  // ownership check: 200 = shared with the caller, 400 = the caller owns the
  // agent, 404 = not shared with them.
  async getMyDim3(agentId) {
    const response = await defaultAxiosInstance.get(`/diy-agents/${agentId}/my-dim3`);
    return response.data;
  }

  async saveMyDim3(agentId, knowledgeBaseDim3) {
    const response = await defaultAxiosInstance.put(`/diy-agents/${agentId}/my-dim3`, {
      knowledge_base_dim3: knowledgeBaseDim3,
    });
    return response.data;
  }

  async resetMyDim3(agentId) {
    const response = await defaultAxiosInstance.delete(`/diy-agents/${agentId}/my-dim3`);
    return response.data;
  }
}

const resourceSharingService = new ResourceSharingService();
export default resourceSharingService;
